import React from 'react'
import MobileImg from './../../../assets/images/png/mobileImg.png'
import { Link } from 'react-router-dom'

function DownloadApp() {
    return (
        <div className='wrapper mx-auto py-md-4 py-xl-5 pt-md-3 my-5 mb-md-2 mb-lg-0'>
            <div className='bg-follygradient rounded-4 d-flex flex-column flex-sm-row align-items-center mt-lg-4'>
                <div className='w-100 px-0 px-xl-5'>
                    <div className='px-3 pt-3 pt-sm-2 pt-md-4 pb-2 py-md-4 py-lg-0'>
                        <h2 className='text-white fs-35 fw-bold'>
                            Spinning without limits!
                        </h2>
                        <p className='text-white fs-18 fw-medium opacity-75 my-2 mt-md-3 mb-md-4'>Whole kingdom of Bitkingz can fit into your pocket and you can take it with you wherever you are.</p>
                        <Link to={'/'} className='text-white d-inline-block fw-fw-semibold fs-18 text-decoration-none bg-cherrygradient hover-bg-cherrygradient rounded-3 px-4 py-2'>Download App</Link >
                    </div>
                </div>
                <div className='downloadappimg-wrapper w-100 pe-lg-4 pe-xl-5'>
                    <div className='max-w-390 ms-sm-auto me-lg-5 mt--106'>
                        <img src={MobileImg} alt="Mobile Img" className='img-fluid' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DownloadApp